const techStackArray = [
  {
    id: "react",
    iconName: "React",
    imageUrlDefault: "https://api.iconify.design/mdi/react.svg?color=%23454545",
    imageUrlOnHover: "https://api.iconify.design/mdi/react.svg?color=%2361dbfb",
  },
  {
    id: "angular",
    iconName: "Angular",
    imageUrlDefault:
      "https://api.iconify.design/mdi/angular.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/mdi/angular.svg?color=%23dd1b16",
  },
  {
    id: "js",
    iconName: "Javascript",
    imageUrlDefault:
      "https://api.iconify.design/simple-icons/javascript.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/logos/javascript.svg?width=32&height=32",
  },
  {
    id: "nodejs",
    iconName: "NodeJS",
    imageUrlDefault:
      "https://api.iconify.design/mdi/nodejs.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/logos/nodejs-icon.svg?width=32&height=32",
  },
  {
    id: "androidstudio",
    iconName: "Android Studio",
    imageUrlDefault:
      "https://api.iconify.design/mdi/android-studio.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/mdi/android-studio.svg?color=%233DDC84",
  },
  {
    id: "kotlin",
    iconName: "Kotlin",
    imageUrlDefault:
      "https://api.iconify.design/simple-icons/kotlin.svg?color=%23454545",
    imageUrlOnHover: "https://api.iconify.design/logos/kotlin-icon.svg",
  },
  {
    id: "mongodb",
    iconName: "MongoDB",
    imageUrlDefault:
      "https://api.iconify.design/simple-icons:mongodb.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/simple-icons:mongodb.svg?color=%2341aa51",
  },

  {
    id: "mui",
    iconName: "MUI",
    imageUrlDefault:
      "https://api.iconify.design/simple-icons/mui.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/simple-icons/mui.svg?color=%232196f3",
  },
  {
    id: "flutter",
    iconName: "Flutter",
    imageUrlDefault:
      "https://api.iconify.design/simple-icons/flutter.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/logos/flutter.svg?width=32&height=32",
  },
  {
    id: "dart",
    iconName: "Dart",
    imageUrlDefault:
      "https://api.iconify.design/simple-icons/dart.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/logos/dart.svg?width=32&height=32",
  },
  {
    id: "figma",
    iconName: "Figma",
    imageUrlDefault: "https://api.iconify.design/cib/figma.svg?color=%23454545",
    imageUrlOnHover:
      "https://api.iconify.design/logos/figma.svg?width=32&height=32",
  },
];

module.exports = {
  techStackArray,
};
